import React from 'react'
import FieldColumn from '../field-column'
import { Field } from 'formik'
import MultiSelectField from '../../form/fields/multi-select'
import { PeriodSummaryStatus } from '../../../api/period-summaries'

/**
 * Options du multiselect pour les statuts de pré-facturation.
 * Reflète l'enum PeriodSummaryStatus (workflow d'annulation des contrats tripartites).
 */
const PRE_BILLING_STATUS_OPTIONS: { value: PeriodSummaryStatus; label: string }[] = [
  { value: PeriodSummaryStatus.active, label: 'Actif' },
  { value: PeriodSummaryStatus.cancellationRequested, label: 'Annulation demandée' },
  { value: PeriodSummaryStatus.cancelled, label: 'Annulé' },
]

/**
 * Composant de filtre multiselect pour les statuts des pré-facturations.
 * Permet de filtrer la liste selon un ou plusieurs statuts du cycle de vie.
 */
const PreBillingStatusFilterField: React.FC = () => {
  return (
    <FieldColumn>
      <Field
        label="Statut"
        name="status"
        component={MultiSelectField}
        options={PRE_BILLING_STATUS_OPTIONS}
        placeholder="Choisir les statuts..."
      />
    </FieldColumn>
  )
}

export default PreBillingStatusFilterField
